<template>
	<div v-bind:class="{'nav-open': $sidebar.showSidebar}">
		<notifications transition-name="notification-list" transition-mode="out-in"></notifications>
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
	// Loading some plugin css asynchronously
	import('sweetalert2/dist/sweetalert2.css')
	import('vue-notifyjs/themes/default.css')
	export default {}
</script>
<style lang="scss">
	.notifications.vue-notifyjs {
		.notification-list-move {
			transition: transform 0.3s, opacity 0.4s;
		}
		.notification-list-item {
			display: inline-block;
			margin-right: 10px;

		}
		.notification-list-enter-active, .notification-list-leave-active {
			transition: opacity 0.4s;
		}
		.notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
		{
			opacity: 0;
		}
	}
	/* ===========
	   Helper classes
	 =============*/
	.p-0 {
		padding: 0px !important;
	}
	.p-t-0 {
		padding-top: 0px !important;
	}
	.p-t-10 {
		padding-top: 10px !important;
	}
	.p-b-0 {
		padding-bottom: 0px !important;
	}
	.p-b-10 {
		padding-bottom: 10px !important;
	}
	.m-0 {
		margin: 0px !important;
	}
	.m-r-5 {
		margin-right: 5px;
	}
	.m-r-10 {
		margin-right: 10px;
	}
	.m-r-15 {
		margin-right: 15px !important;
	}
	.m-r-20 {
		margin-right: 20px !important;
	}
	.m-r-25 {
		margin-right: 25px !important;
	}
	.m-l-5 {
		margin-left: 5px;
	}
	.m-l-10 {
		margin-left: 10px;
	}
	.m-l-15 {
		margin-left: 15px;
	}
	.m-l-20 {
		margin-left: 20px;
	}
	.m-t-5 {
		margin-top: 5px !important;
	}
	.m-t-0 {
		margin-top: 0px;
	}
	.m-t-10 {
		margin-top: 10px !important;
	}
	.m-t-15 {
		margin-top: 15px !important;
	}
	.m-t-20 {
		margin-top: 20px !important;
	}
	.m-t-30 {
		margin-top: 30px !important;
	}
	.m-t-40 {
		margin-top: 40px !important;
	}
	.m-b-0 {
		margin-bottom: 0px !important;
	}
	.m-b-5 {
		margin-bottom: 5px;
	}
	.m-b-10 {
		margin-bottom: 10px;
	}
	.m-b-15 {
		margin-bottom: 15px;
	}
	.m-b-20 {
		margin-bottom: 20px;
	}
	.m-b-25 {
		margin-bottom: 25px;
	}
	.m-b-30 {
		margin-bottom: 30px !important;
	}
	.font-light {
		font-weight: 300;
	}
	.font-normal {
		font-weight: normal;
	}
	.font-13 {
		font-size: 13px;
	}
	.font-12 {
		font-size: 12px;
	}
	.font-11 {
		font-size: 11px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue